require('./src/style/index');
const req = require.context('./src', true, /^\.\/[^_][\w-]+\/style\/index\.tsx?$/);

req.keys().forEach(mod => {
  req(mod);
});

module.exports = require('./src/index');
